import { ListItemButton } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import React from 'react';
import { H } from '../common/Layout';
import { useStyling } from '../common/Theme';
import Carousel from '../common/components/Carousel';
import { Field, fieldPreview, Type, typePreview } from './attributes';
import DefaultFieldPreview from './default/DefaultFieldPreview';
import DefaultTypePreview from './default/DefaultTypePreview';

const TILE_WIDTH = 240;
const MARGIN = 1;
const PADDING = 1;

export type FieldSelectorProps = {
    available: Field[];
    isSelected: (field) => boolean;
    isDisabled: boolean;
    onClick: (type: Type) => void;
    isType?: boolean;
    carousel?: boolean;
};

export const getPreviewComponent = (isType, field) => {
    if (isType && typePreview[field.fieldType]) {
        return typePreview[field.fieldType];
    } else if (!isType && fieldPreview[field.fieldType]) {
        return fieldPreview[field.fieldType];
    } else {
        return isType ? DefaultTypePreview : DefaultFieldPreview;
    }
};

export const getTileStyle = (theme: Theme, isSelected, isLast, marginBottom = 0): SxProps => ({
    border: `2px solid ${isSelected ? theme.palette.primary.main : theme.palette.divider}`,
    borderRadius: 1,
    height: '78px',
    alignItems: 'flex-start',
    mr: isLast ? 0 : 1,
    mb: marginBottom,
    p: PADDING,
    maxWidth: TILE_WIDTH,
    minWidth: TILE_WIDTH,
    overflow: 'hidden'
});

export default (props: FieldSelectorProps) => {
    const { onClick, available, isSelected, isType, carousel } = props;
    const { theme } = useStyling();
    return carousel ? (
        <Carousel>
            {available.map((field, index) => {
                const Preview = getPreviewComponent(isType, field);
                const selected = isSelected(field);
                const isLast = index === available.length - 1;
                return (
                    <ListItemButton
                        key={index}
                        sx={getTileStyle(theme, selected, isLast)}
                        onClick={() => onClick(field)}
                    >
                        <Preview field={field} />
                    </ListItemButton>
                );
            })}
        </Carousel>
    ) : (
        <H sx={{ flexWrap: 'wrap', mx: 2 }}>
            {available.map((field, index) => {
                const Preview = getPreviewComponent(isType, field);
                const selected = isSelected(field);
                const isLast = index === available.length - 1;
                return (
                    <ListItemButton
                        key={index}
                        sx={getTileStyle(theme, selected, isLast, 1)}
                        onClick={() => onClick(field)}
                    >
                        <Preview field={field} />
                    </ListItemButton>
                );
            })}
        </H>
    );
};
